import React from 'react';
import type { StudioCaptureForm } from './types';

interface CompeteFormPickerProps {
  forms: StudioCaptureForm[];
  selectedToken?: string;
  onSelect: (form: StudioCaptureForm) => void;
  isLoading?: boolean;
  emptyMessage?: string;
}

export const CompeteFormPicker: React.FC<CompeteFormPickerProps> = ({
  forms,
  selectedToken,
  onSelect,
  isLoading = false,
  emptyMessage = 'No forms yet. Create one in Compete Studio, then come back.',
}) => {
  if (isLoading) {
    return <p className="text-sm text-gray-500">Loading your Studio forms…</p>;
  }

  if (forms.length === 0) {
    return <p className="text-sm text-gray-600">{emptyMessage}</p>;
  }

  return (
    <ul className="space-y-2">
      {forms.map(form => {
        const selected = form.shareToken === selectedToken;
        return (
          <li key={form.shareToken}>
            <button
              type="button"
              onClick={() => onSelect(form)}
              className={`w-full text-left px-4 py-3 rounded-lg border transition-colors ${
                selected
                  ? 'border-primary-500 bg-primary-50'
                  : 'border-gray-200 hover:border-primary-300 hover:bg-gray-50'
              }`}
            >
              <span className="block font-medium text-gray-900">{form.name}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};
